import { apiCall, isBackendConfigured } from './api-call'
import { SubmitSupportRequestInput } from '../_types/support'

/**
 * Sends a QuickPass app-support request to the QuickCasa team (NOT the
 * property manager — they only handle the renter's home). Returns true on
 * success. Returns false when the backend is unconfigured or the call fails.
 *
 * @param {SubmitSupportRequestInput} input - the renter id, help category, and message
 * @returns {Promise<boolean>}
 */
const submitSupportRequest = async (
  input: SubmitSupportRequestInput,
): Promise<boolean> => {
  if (isBackendConfigured() === false) {
    return false
  }

  try {
    const response = await apiCall({
      group: 'quickpass',
      command: 'submitsupportrequest',
      data: {
        quickPassUserId: input.quickPassUserId,
        category: input.category,
        message: input.message,
      },
    })

    return response.code === 200
  } catch (error) {
    console.warn('[support] submit failed —', error)
    return false
  }
}

export { submitSupportRequest }
